export enum ListTypeRoutes {
    ListType = ':id',
    ListTypeList = ''
}
